<template>
  <div class="multi-job">
    <div class="category-item" v-for="category in jobList">
      <div class="category-name">
        {{ category.name }}
      </div>
      <div
        class="list-item"
        :class="{ 'has-border': index + 1 < category.list.length }"
        v-click-feedback="'deep-background'"
        v-for="(item, index) in category.list"
        :key="index"
      >
        <div class="list-item-inner" @click="selectJob(item)">
          <div class="list-item-inner2" :class="{ 'show-default': isSelf }">
            <div class="list-row">{{ item[model.showKey] }}</div>
            <div v-if="model.extraShowKey" class="list-row extra-text">
              {{ hasExtrashow(item, model.extraShowKey) }}
            </div>
            <span
              class="img-wrapper voice-wrapper"
              v-if="voiceInput && item.formType == '2001' && model.mode === 'document'"
              v-click-feedback="'deep-background'"
              @click.stop.prev="onVoiceClick(item)"
            >
              <img :src="images.btnMicrophone" alt="" class="img-responsive" />
            </span>
          </div>
        </div>
        <div class="default-job" v-if="isSelf" @click="doDefaultJob(item, model, $event)">
          <div class="default-job-inner">
            <img class="check-img" :src="item.docDefault ? images.checked : images.unChecked" />
            <div class="text">{{ $t('global-1.key155', { cm: '默认' }) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*
 */
import btnMicrophone from 'assets/images/application/voice/btn-microphone@3x.png';
import backBlueImg from 'assets/images/application/subsidies-detail/back-blue@3x.png';
import searchImg from 'assets/images/common/search@3x.png';
import clearSearchImg from 'assets/images/common/clear-btn@2x.png';
import closeImg from 'assets/images/common/close-v2@2x.png';
import unChecked from 'assets/images/common/rounded-checkbox-blank@3x.png';
import checked from 'assets/images/common/rounded-checkbox@3x.png';
import closeV3 from 'assets/images/common/close-v3.png';
import back from 'assets/images/common/back.png';
import search from 'assets/images/common/search.png';

import { defaultUserJobId } from 'api/common-document';

export default {
  name: 'document-creator-v2',
  mixins: [],
  props: {
    jobList: {
      type: Array,
      default() {
        return [];
      },
    },
    model: {
      type: Object,
      default() {
        return {};
      },
    },
    isSelf: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      voiceInput: '',
      images: {
        btnMicrophone,
        backBlueImg,
        searchImg,
        clearSearchImg,
        closeImg,
        unChecked,
        checked,
        closeV3,
        back,
        search,
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    doDefaultJob(item, model, e) {
      e.preventDefault();
      let currentDocDefault = item.docDefault;
      this.jobList.forEach((category) => {
        let list = category.list;
        list.forEach((item) => {
          item.docDefault = false;
        });
      });
      item.docDefault = !currentDocDefault;
      let cancel = false;
      if (currentDocDefault) {
        cancel = true;
      }
      this.$plugins.showLoading({
        type: 'FIXED',
      });
      defaultUserJobId(item.id, cancel).then(
        (res) => {
          this.$plugins.hideLoading();
          this.currentUserSelectJob = item;
        },
        (error) => {
          this.$plugins.hideLoading();
          item.docDefault = currentDocDefault;
        }
      );

      this.$emit('multiJobEvent', {
        type: 'default',
        job: item,
        docDefault: item.docDefault,
      });
    },
    selectJob(job) {
      this.$emit('multiJobEvent', {
        type: 'select',
        job,
      });
    },
    onVoiceClick() {},
    hasExtrashow(item, showArr) {
      let temp = '';
      showArr.forEach((e, index) => {
        if (index == 0) {
          temp += item[e];
        } else if (item[e]) {
          temp += '-' + item[e];
        }
      });
      return temp;
    },
  },
  mounted() {},
  components: {},
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/variable.scss';

.multi-job {
  .category-name {
    background: #f8f8f8;
    height: 64px;
    //font-family: PingFangSC-Regular;
    font-size: 30px;
    line-height: 64px;
    color: #8c96b4;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    padding: 0 40px;
  }

  .list-item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;
    font-size: px(30);
    padding: px(30) px(40);

    &.has-border {
      &::after {
        content: '';
        display: block;
        position: absolute;
        left: px(30);
        bottom: 0;
        width: calc(100% - #{px(60)});
        height: 2px;
        background: #ededed;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
      }
    }

    &.has-voice-input .list-row {
      /* 100 * 2 + 4 避免与录音按钮重叠*/
      width: calc(100% - #{px(204)});
    }

    .list-row {
      width: 100%;
      flex-shrink: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-family: PingFangSC-Medium;
      font-size: px(32);
      color: #0a0f1e;
    }

    .list-item-inner {
      text-align: left;
      width: 100%;

      .list-item-inner2 {
        text-align: left;
        width: 100%;

        &.show-default {
          width: 80%;
        }
      }
    }

    .default-job {
      position: absolute;
      top: 0;
      right: px(40);
      bottom: 0;

      .default-job-inner {
        display: flex;
        height: 100%;
        align-items: center;

        .check-img {
          width: px(28);
          height: px(28);
        }

        .text {
          font-family: PingFangSC-Regular;
          font-size: px(26);
          color: #505564;
          line-height: px(28);
          margin-left: px(12);
        }
      }
    }

    .extra-text {
      font-family: PingFangSC-Regular;
      font-size: px(24);
      color: #8c96b4;
    }
  }
}
</style>
